<template>
  <form ref="form" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <div class="l-page l-page--message-edit-condition">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w500">
            <div class="c-title__text c-title__text--blue u-fs34">配信対象数を確認する</div>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit p-message-edit--delivery-segment-group">
            <div class="c-title">
              <div class="c-title__text u-fs24">配信条件を選ぶ</div>
            </div>
            <div class="p-message-edit-list p-message-edit-list--first">
              <div class="p-message-edit-list__item">
                <div class="c-select-card">
                  <ul class="c-select-card-list">
                    <li class="c-select-card-list__item">
                      <label class="c-select-card__label">
                        <input
                          v-model="conditionType"
                          type="radio"
                          name="delivery_condition_type"
                          value="1"
                        />
                        <div class="c-select-card__item">
                          <div class="c-icon-circle c-icon-circle--purple u-wh80">
                            <div class="c-icon-circle__item c-icon-circle__item--white u-wh44">
                              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/assets/img/sprite.svg#segment-user" />
                              </svg>
                            </div>
                          </div>
                          <div class="c-select-card-content">
                            <div class="c-select-card-content__title">セグメント配信</div>
                            <div class="c-select-card-content__text">指定ページへの訪問ユーザーや端末・OSなど</div>
                            <div class="c-select-card-content__text">設定した配信条件でのリーチ数を確認します</div>
                          </div>
                        </div>
                      </label>
                    </li>
                    <li class="c-select-card-list__item">
                      <label class="c-select-card__label">
                        <input
                          v-model="conditionType"
                          type="radio"
                          name="delivery_condition_type"
                          value="2"
                        />
                        <div class="c-select-card__item">
                          <div class="c-icon-circle c-icon-circle--orange u-wh80">
                            <div class="c-icon-circle__item c-icon-circle__item--white u-wh44">
                              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/assets/img/sprite.svg#all-user" />
                              </svg>
                            </div>
                          </div>
                          <div class="c-select-card-content">
                            <div class="c-select-card-content__title">
                              全配信
                            </div>
                            <div class="c-select-card-content__text">すべてのオプトインを対象とした場合の</div>
                            <div class="c-select-card-content__text">リーチ数を確認します</div>
                          </div>
                        </div>
                      </label>
                    </li>
                  </ul>
                  <div class="c-error c-error--balloon">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
              <div v-show="conditionType != 2" class="p-message-edit-condition-select-block">
                <div class="c-title">
                  <div class="c-title__text">セグメントの接続タイプ</div>
                </div>
                <div class="p-message-edit-list__item">
                  <div class="c-radio u-w100p">
                    <ul class="c-radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label u-w300">
                          <input
                            v-model="params.conditionJoinType"
                            type="radio"
                            name="condition_join_type"
                            value="AND"
                          />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">かつ(AND) </div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item u-w300">
                        <label class="c-radio__label">
                          <input
                            v-model="params.conditionJoinType"
                            type="radio"
                            name="condition_join_type"
                            value="OR"
                          />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">または(OR)</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item u-w300">
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <message-select-condition
                v-show="conditionType != 2"
                ref="messageSelectCondition"
                :is-enable-topic-condition="true"
                :is-enable-hybrid-condition="true"
                :width="456"
                :base-conditions="conditionInfo.conditions"
                :base-condition-source-types="conditionInfo.conditionSourceTypes"
                :topic-conditions="conditionInfo.topicConditions"
                :on-select="onSelectConditionChange"
                :initial-data="{ baseConditions: [], topicConditions: [] }"
              />

            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
        </div>
        <reach-count ref="refReachCount" :failure-message="reachCountFailureMessage" @loading-change="isLoading = $event" />
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--gray u-w320 u-h50 u-fs20"
            type="button"
            name="prev"
            value="prev"
            @click="onBackClick()"
          >
            <p class="c-btn__text">キャンセル</p>
          </button>
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoading }"
            :disabled="isLoading"
            type="button"
            name="next"
            value="next"
            @click="onSearchClick()"
          >
            <p class="c-btn__text">配信対象数を確認</p>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

    <script>
export default {
  props: {
    isEnableTopicCondition: Boolean,
    isEnableHybridCondition: Boolean,
    breadcrumbData: Array,
    conditionInfo: Object,
    csrfToken: String,
  },
  data() {
    return {
      conditionType: null,
      reachCountFailureMessage: '配信される予測数を取得できませんでした。\n少し時間をおいてから「配信対象数を確認」を押してください。',
      isSegment: false,
      createType: null,
      selectedConditionId: null,
      isLoading: false,
      params: {
        conditions: [],
        topicConditions: [],
        conditionJoinType: 'AND',
      },
    }
  },
  mounted: function () {
    import('../../funcs/components/select').then(module => {
      module.Select();
    });

    this.conditionDetailList = [];

    // 各KeyのConditionDetailを１個ずつ作成しておく
    Object.keys(this.conditionInfo.conditionKeyTypes).map(conditionKey => {
      this.conditionDetailList[conditionKey] = [];
      this.conditionDetailList[conditionKey].push({
        value: '',
        operator: 'eq'
      });
    });

    // 初期選択値の設定
    this.params = {
      conditions: [],
      topicConditions: [],
      conditionJoinType: 'AND',
    }

    this.conditionType = 2;
  },
  methods: {
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    onBackClick: function () {
      location.href = this.conditionInfo.listUrl;
    },
    onSearchClick: function () {
      if (this.isLoading) {
        return;
      }
      if (this.conditionType == 1) {

        // 配信条件を1つ以上選択していない場合はエラーメッセージを表示
        if (this.params.conditions.length < 1 && this.params.topicConditions.length < 1) {
          this.$refs.messageSelectCondition.setErrorBaseCondition('1つ以上の配信条件を選択してください')
          this.$refs.messageSelectCondition.setErrorTopicCondition('1つ以上の配信条件を選択してください')
          return;
        }

        this.$refs.refReachCount.getReachCount(this.params);

      } else if (this.conditionType == 2) {
        this.$refs.refReachCount.getReachCount();
      } else {
        this.showErrors({
          'delivery_condition_type': '配信条件を選択してください'
        });
      }
    },
    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    onSelectRegionListItemChange: function(regions, prefectures) {
      this.regions = regions;
      this.prefectures = prefectures;
    },
    onSelectConditionChange: function(baseConditions, topicConditions) {
      this.params.conditions = baseConditions
        .filter((item) => item.id)
        .map((item) => item.id);
      this.params.topicConditions = topicConditions
        .filter((item) => item.id)
        .map((item) => item.id);
    }
  }
}
    </script>
